export default "__VITE_ASSET__Ch28v8Y___"